import { render, staticRenderFns } from "./_activeTab.vue?vue&type=template&id=6734f10f&scoped=true"
import script from "./_activeTab.vue?vue&type=script&lang=js"
export * from "./_activeTab.vue?vue&type=script&lang=js"
import style0 from "./_activeTab.vue?vue&type=style&index=0&id=6734f10f&prod&lang=scss&scoped=true"
import style1 from "./_activeTab.vue?vue&type=style&index=1&id=6734f10f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6734f10f",
  null
  
)

/* custom blocks */
import block0 from "./_activeTab.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports